// extracted by mini-css-extract-plugin
export default {"mainSection":"MainSection_mainSection__t630Q"};